<template>
  <div>
    <ValidationObserver @submit="addAssignmentMarks">
      <UiModalContainer
        footer-classes="flex justify-end gap-3"
        :modal-show="modal"
        @handleClick="handleClick"
      >
        <template v-slot:header>
          <span>
            <span>Student Assignment Add Marks</span>
          </span>
        </template>
        <div>
          <div>
            <Heading :heading="studentName" />
            <DetailCard :details="assignment" />
          </div>
          <div v-if="studentAttechment.length" class="mt-5">
            <Heading heading="Attachments" />
            <TableWrapper id=" studentAttachmentTable">
              <THead>
                <TRHead>
                  <TH v-for="(head, index) in attachmentsTableHeaders" :key="index">
                    {{ head }}
                  </TH>
                </TRHead>
              </THead>
              <TBody>
                <TRBody v-for="(attachment, index) in studentAttechment" :key="index">
                  <TD>
                    {{ attachment.file_name || GENERAL_CONSTANTS.NOT_APPLICABLE }}
                  </TD>
                  <TD>
                    <a
                      :href="attachment.url"
                      class="focus:outline-none focus:shadow-md text-base text-white font-roboto h-8 w-8 flex justify-center items-center primary-button mx-auto"
                      download
                    >
                      <span>Download</span>
                    </a>
                  </TD>
                </TRBody>
              </TBody>
            </TableWrapper>
          </div>
          <UiInputBox
            v-model="obtainedMarks"
            type="text"
            name="addMarks"
            title="ADD_MARKS"
            class="mt-2"
            :rules="`max_value:${assignment.totalMarks}|double|required`"
            placeholder="ADD_MARKS"
          />
          <UiInputBox
            v-model="description"
            type="textarea"
            name="Description"
            title="DESCRIPTION"
            placeholder="DESCRIPTION"
            class="mt-2"
            :rules="description && 'between:15,1000'"
          />
        </div>
        <template v-slot:footer>
          <button
            class="focus:outline-none focus:shadow-md text-base text-white font-roboto h-8 flex justify-center items-center primary-button-outline"
            @click="emit('toggle')"
          >
            Cancel
          </button>
          <button
            class="focus:outline-none focus:shadow-md text-base text-white font-roboto h-8 flex justify-center items-center primary-button"
          >
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>Add Marks</span>
          </button>
        </template>
      </UiModalContainer>
    </ValidationObserver>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'

// Components
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import { Form as ValidationObserver } from 'vee-validate'
import DetailCard from '@src/components/UiElements/DetailCard.vue'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import { buildWhereQuery } from '@src/utils/filters/index'
import UiInputBox from '@src/components/UiElements/UiInputBox.vue'
import RULE_CONSTANTS from '@src/constants/rule.constants.js'
import Heading from '@/src/components/Heading.vue'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'

// Store
import { useStore } from 'vuex'
const store = useStore()

// Props
const props = defineProps({
  modal: {
    type: Boolean,
    default: false,
  },
  assignment: {
    type: Object,
    default: () => {},
  },
  id: {
    type: String,
    default: '',
    required: true,
  },
  studentName: {
    type: String,
    default: '',
  },
  studentAttechment: {
    type: Array,
    default: () => [],
  },
})

// Emits
const emit = defineEmits(['toggle'])

// States
const obtainedMarks = ref(null)
const attachmentsTableHeaders = ['Title', 'Download']
const description = ref('')
const isLoading = ref(false)
// Methods
const getPayload = () => {
  let resultList = [
    {
      obtained_marks: obtainedMarks.value,
      evaluator_comment: description.value || '',
      id: props.id,
    },
  ]
  return resultList
}

const addAssignmentMarks = () => {
  isLoading.value = true
  const payload = { student_assignment_marks: getPayload() }
  addStudentsAssignmentMarks(payload)
    .then(() => {
      handleClick('close', 'fetch')
    })
    .finally(() => {
      isLoading.value = false
    })
}

const handleClick = (eventName, payload) => {
  switch (eventName) {
    case 'close':
      emit('toggle', payload)
      break
  }
}
// Actions
const addStudentsAssignmentMarks = (payload) => {
  return store.dispatch('assignment/addStudentsAssignmentMarks', payload)
}
</script>
